import { render, staticRenderFns } from "./SocialPrivacyPolicyComponent.vue?vue&type=template&id=2f318a1e&"
import script from "./SocialPrivacyPolicyComponent.vue?vue&type=script&lang=js&"
export * from "./SocialPrivacyPolicyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports